import TalkBody from './TalkBody.jsx'

// #343: one talk inside a conference — extracted from ConferenceCard so the
// feed card and the conference detail page render a programme the same way
// rather than drifting into two dialects of the same row.
//
// #350: the row is now just a time column plus the shared TalkBody, which is
// the same block a standalone EventCard renders. The card sets a stretched
// link over its whole surface, so the row's contents carry `relative z-10` to
// sit above it. That is inert on the detail page, which has no stretched link,
// and cheaper than parameterising it.

export function talkTime(talk) {
  if (!talk?.startsAtUtc) return { time: '' }
  try {
    return {
      time: new Intl.DateTimeFormat(undefined, {
        weekday: 'short',
        hour: 'numeric',
        minute: '2-digit',
      }).format(new Date(talk.startsAtUtc)),
    }
  } catch {
    return { time: '' }
  }
}

export default function TalkRow({ talk, year }) {
  const { time } = talkTime(talk)

  return (
    // #334: `items-baseline`, not the old `pt-0.5` nudge. The time is 12px and
    // the title is now 16px, so no fixed offset lines them up at both sizes —
    // but a flex row aligns each item's FIRST baseline, which is exactly the
    // two lines in question.
    <li className="relative z-10 flex items-baseline gap-3 border-t border-slate-100 py-3 first:border-t-0">
      {/* w-20 was one character too narrow: "Thu 10:20 AM" wrapped onto two
          lines while "Thu 4:00 AM" did not, so the column's height changed
          from row to row. w-28 clears the widest form with room to spare, and
          whitespace-nowrap makes the guarantee explicit rather than incidental.
          #350: the calendar/social bar lives INSIDE this second column, which
          is what lines it up with the talk core rather than the card edge. */}
      <div className="w-28 shrink-0 whitespace-nowrap text-xs font-medium tabular-nums text-brand-700">
        {time}
      </div>
      <div className="min-w-0 flex-1">
        <TalkBody talk={talk} year={year} />
      </div>
    </li>
  )
}
